import { DataSource, Layout, Panel, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutBrltlFuelSurchargeProfile extends Layout {
    panelCalculateOptions: Panel;
    panelCustomTable: Panel;
    panelFormula: Panel;
    panelSpace2: Panel;
    panelSpacer1: Panel;
    panelSpacer3: Panel;
    panelTop: Panel;
    sourceCustomerFuel: DataSource;
    switchCalculateUsing: Switch;
    switchFuelCreditAllowed: Switch;
    textboxAmount: Textbox;
    textboxApplyDoeRate: Textbox;
    textboxBasePrice: Textbox;
    textboxCustomFscHdrId: Textbox;
    textboxDateOpt: Textbox;
    textboxDelayDays: Textbox;
    textboxFscCycleCode: Textbox;
    textboxFuelPercent: Textbox;
    textboxFuelVariance: Textbox;
    textboxLtlCode: Textbox;
    textboxLtlDescr: Textbox;
    textboxMethod: Textbox;
    textboxRegion: Textbox;
    textboxRoundSurchgCalc: Textbox;
}
